export const INTERNAL_MESSAGE_ERROR_KEY = '[Internal Message Error]';
export const INTERNAL_MESSAGE_SOURCE = 'pimster-pim';
export const INTERNAL_MESSAGE_ALLOWED_SOURCE = 'pimster-embed';
